import { render } from "./GuestsReportPage.vue?vue&type=template&id=50147fcf"
import script from "./GuestsReportPage.vue?vue&type=script&lang=js"
export * from "./GuestsReportPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__